<template>
  <div class="no-nav">
    <Hero :title="product.name" link="productos" texto="Volver a productos" clase="defaultHero" />

    <section class="single-product">
      <div class="single-product-images">
        <div v-for="image in product.images">
          <img :src="image" alt />
        </div>
      </div>

      <div class="single-product-info">
        <article class="desc">
          <div class="single-product-color">
            <div>
              <h3>Acabados</h3>
              <div v-for="color in product.colors">
                <img :src="color.images" alt />
                <p>{{color.name}}</p>
              </div>
            </div>
          </div>

          <h3>Descripción</h3>
          <h6>{{product.description.slice(3, -4)}}</h6>
        </article>
      </div>
    </section>

    <section class="product-extras">
      <h6>detalles</h6>
      <ul v-for="extra in product.extras" class="extras">
        <li>{{extra.slice(0, -1)}}</li>
      </ul>
    </section>
    <section class="product-extras">
      <h6>códigos</h6>
      <ul v-for="tag in product.tags" class="extras">
        <li>{{tag.slice(0, -1)}}</li>
      </ul>
    </section>
  </div>
</template>

<script>
import Hero from "@/components/Hero.vue";
import { db } from "../firebase";
export default {
  name: "producto",
  components: {
    Hero
  },
  data() {
    return {
      product: {},
      datos: this.$route.params.id
    };
  },
  firestore() {
    return {
      product: db.collection("products").doc(this.datos)
    };
  },
  methods: {
    getDatos() {}
  }
};
</script>

<style lang="scss" scoped>
.no-nav {
  margin-top: -5rem;
}
/* single product*/

.single-product {
  padding: 5rem 0 0 0;
}

.single-product-images {
  width: 80vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 50px;
}

.single-product-images img {
  width: 80%;
  display: block;
}
.single-product-color {
  width: 80vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 50px;
}

.single-product-color img {
  width: 10%;
  display: block;
}

.single-product-info {
  width: 80vw;
  display: grid;
  grid-template-columns: 1fr;
  margin: 2rem auto;
}

.desc,
.info {
  margin: 1rem 0;
}

.desc h3 {
  text-transform: capitalize;
  letter-spacing: var(--mainSpacing);
}

.desc p {
  line-height: 1.5;
}

.info h3,
.info h6 {
  text-transform: capitalize;
  letter-spacing: var(--mainSpacing);
}

.info h6 {
  font-weight: 300;
}

.product-extras {
  width: 80vw;
  margin: 0 auto 3rem auto;
}

.product-extras h6 {
  text-transform: capitalize;
  letter-spacing: var(--mainSpacing);
}

.extras {
  list-style-type: none;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
  grid-column-gap: 2rem;
  grid-row-gap: 1rem;
}

@media screen and (min-width: 992px) {
  .single-product-images,
  .single-product-info,
  .product-extras {
    width: 95vw;
    max-width: 1170px;
  }

  .single-product-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
  }

  .info {
    padding-left: 3rem;
  }
}
</style>